import { Injectable } from '@angular/core';
import { CanActivate, GuardsCheckStart, NavigationEnd, Router } from '@angular/router';

import { AtxPermissionModel } from '../model/atx-permission.model';

@Injectable()
export class AtxPermissionGuard implements CanActivate {
    private url;

    constructor(
        private readonly router: Router,
        private readonly model: AtxPermissionModel,
    ) {}

    public canActivate() {
        const hasAccess = !!this.model.roles
            .find((role) => !!(this.model.rolesRequired && this.model.rolesRequired.indexOf(role) >= 0));

        this.redirect(hasAccess);

        return hasAccess;
    }

    private redirect(hasAccess: boolean) {
        if (!hasAccess) {
            this.router.navigateByUrl('/not-found')
        }
    }
}
